module.exports = __webpack_public_path__ + "Roboto-Medium.b9d01ac1742192a7c9d3.woff";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/fonts/Roboto-Medium.woff
// module id = ../../../../../src/assets/fonts/Roboto-Medium.woff
// module chunks = styles